module.exports = __webpack_public_path__ + "static/media/Portrait-10261.3cb1b547.jpg";